/* Recalculate server-side discounts once when the customer context changes. */
(() => {
  const config = document.getElementById('rok-cart-customer-refresh');
  if (!config) return;
  const identity = config.dataset.customer;
  const storageKey = 'rok-cart-customer-v1';
  let previous;
  try { previous = sessionStorage.getItem(storageKey); } catch (_) {}
  const remember = () => { try { sessionStorage.setItem(storageKey, identity); } catch (_) {} };
  if (previous === identity || (previous == null && identity === 'guest') || config.dataset.empty === 'true') {
    remember();
    config.dataset.state = 'unchanged';
    return;
  }
  let edited = false;
  const trackEdit = (event) => {
    if (event.target.closest('cart-items, cart-drawer, #main-cart-footer')) edited = true;
  };
  document.addEventListener('input', trackEdit, true);
  document.addEventListener('click', trackEdit, true);
  const regions = [
    { id: 'main-cart-items', selector: '.js-contents' },
    { id: 'main-cart-footer', selector: '.js-contents' },
    { id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' },
    { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
  ].map((region) => {
    const element = document.getElementById(region.id);
    return element && { ...region, element, section: region.section || element.dataset.id };
  }).filter(Boolean);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  config.dataset.state = 'refreshing';
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    signal: controller.signal,
    // No quantities, properties, notes, attributes or discount codes are changed.
    body: JSON.stringify({ updates: {}, sections: [...new Set(regions.map((r) => r.section))], sections_url: window.location.pathname })
  }).then(async (response) => {
    if (!response.ok) throw new Error('Cart refresh failed');
    const cart = await response.json();
    if (cart.errors) throw new Error('Cart refresh failed');
    if (edited) { config.dataset.state = 'deferred'; return; }
    const replacements = regions.map((region) => {
      const html = cart.sections?.[region.section];
      if (!html) throw new Error('Missing HTML: ' + region.section);
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(region.selector);
      const target = region.element.matches(region.selector) ? region.element : (region.element.querySelector(region.selector) || (region.id === 'cart-icon-bubble' ? region.element : null));
      if (!source || !target) throw new Error('Missing selector: ' + region.id + ' source=' + !!source + ' target=' + !!target);
      return { source, target };
    });
    replacements.forEach(({ source, target }) => { target.innerHTML = source.innerHTML; });
    remember();
    config.dataset.state = 'ready';
    document.dispatchEvent(new CustomEvent('rok:customer-cart-refreshed'));
  }).catch((error) => {
    // Keep the existing cart and checkout usable; retry on the next page.
    config.dataset.state = 'failed';
    config.dataset.error = error.message;
  }).finally(() => {
    clearTimeout(timeout);
    document.removeEventListener('input', trackEdit, true);
    document.removeEventListener('click', trackEdit, true);
  });
})();
